// extracted by mini-css-extract-plugin
export default {"dialog":"textEditorValuesRender_dialog__JZew6","label":"textEditorValuesRender_label__XnL9n"};